module.exports = __webpack_public_path__ + "img/ptz-icon1.9b05e7ee.svg";